import moment from 'moment';

const formatAge = (date: string): number => {
  let age = moment().diff(date, 'years');
  age = age < 100 ? age : age - 100;
  return age;
};

export default formatAge;
